import React from "react";
import { Search } from "lucide-react";
import CustomDropdown from "../common/CustomDropdown";

const SEARCH_STATUS_OPTIONS = [
    { value: "all", label: "All Statuses" },
    { value: "completed", label: "Completed" },
    { value: "failed", label: "Failed" },
    { value: "processing", label: "Processing" },
    { value: "no_results", label: "No Results" },
];

const SearchListFilters = ({
    searchValue,
    statusValue,
    onSearchChange,
    onStatusChange,
}) => {
    return (
        <div className="grid w-full min-w-0 grid-cols-[minmax(0,1fr)_8.75rem] gap-2">
            <label htmlFor="search-list-filter" className="sr-only">
                Search saved searches
            </label>
            <div className="relative min-w-0">
                <Search
                    size={15}
                    className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
                    aria-hidden="true"
                />
                <input
                    id="search-list-filter"
                    type="search"
                    value={searchValue}
                    onChange={(event) => onSearchChange?.(event.target.value)}
                    placeholder="Filter existing searches..."
                    className="h-10 w-full min-w-0 rounded-xl border border-slate-200 bg-white pl-9 pr-3 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100"
                />
            </div>

            <CustomDropdown
                id="search-status-filter"
                value={statusValue}
                options={SEARCH_STATUS_OPTIONS}
                onChange={onStatusChange}
                ariaLabel="Filter search status"
                className="min-w-0"
            />
        </div>
    );
};

export default SearchListFilters;
